import {
  faClock,
  faCirclePlus,
  faCircleMinus,
  faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';

import {
  ClientStatusEnum,
  ClientStatusLabelEnum,
  RecordTypeEnum,
} from '@app/components/RecordModal/components/RecordDetails/types';
import type { ClientStatuses } from '@app/components/RecordModal/components/RecordDetails/types';
import { ERROR_REQUIRED_FIELD } from '@app/constants';
import { generateSpanWithDataTestId } from '@app/shared/utils';

export const PF = 'record-details';

export const clientStatuses: Array<ClientStatuses> = [
  {
    id: 1,
    status: ClientStatusEnum.WAITING,
    label: ClientStatusLabelEnum.WAITING_LABEL,
    color: '#ADD8E6',
    icon: faClock,
  },
  {
    id: 2,
    status: ClientStatusEnum.CONFIRMED,
    label: ClientStatusLabelEnum.CONFIRMED_LABEL,
    color: '#F0AD4E',
    icon: faCirclePlus,
  },
  {
    id: 3,
    status: ClientStatusEnum.NOVISIT,
    label: ClientStatusLabelEnum.NOVISIT_LABEL,
    color: '#E14F4F',
    icon: faCircleMinus,
  },
  {
    id: 4,
    status: ClientStatusEnum.VISITED,
    label: ClientStatusLabelEnum.VISITED_LABEL,
    color: '#2DA540',
    icon: faCircleCheck,
  },
];

export const mainFields = [
  {
    label: 'Имя',
    name: 'NameFirst',
    required: true,
    rules: [{ required: true, message: ERROR_REQUIRED_FIELD }],
    labelTestid: 'name-label',
    inputTestid: 'name-input',
    maxLength: 60,
  },
  {
    label: 'Фамилия',
    name: 'NameLast',
    labelTestid: 'surname-label',
    inputTestid: 'surname-input',
    maxLength: 60,
  },
];

export const servicesColumns = [
  { id: 0, title: '', className: 'checkbox' },
  {
    id: 1,
    title: generateSpanWithDataTestId('Название', 'service-name-label'),
    className: 'name',
  },
  {
    id: 2,
    title: generateSpanWithDataTestId('Допродажа', 'upsell-label'),
    className: 'employee',
  },
  {
    id: 3,
    title: generateSpanWithDataTestId('Кол-во', 'quantity-label'),
    className: 'quantity',
  },
  {
    id: 4,
    title: generateSpanWithDataTestId('Цена', 'price-label'),
    className: 'price',
  },
  {
    id: 5,
    title: generateSpanWithDataTestId('Скидка', 'discount-label'),
    className: 'discount',
  },
  {
    id: 6,
    title: generateSpanWithDataTestId('К оплате', 'to-pay-label'),
    className: 'total',
  },
  {
    id: 7,
    title: '',
    className: 'delete',
  },
];

export const recordTypes: Array<{
  value: RecordTypeEnum;
  label: string;
}> = [
  {
    value: RecordTypeEnum.INCOMING,
    label: 'Входящая',
  },
  {
    value: RecordTypeEnum.OUTGOING,
    label: 'Исходящая',
  },
  {
    value: RecordTypeEnum.OPERATIVE,
    label: 'Оперативная',
  },
  {
    value: RecordTypeEnum.KROSS,
    label: 'Кросс-запись',
  },
  {
    value: RecordTypeEnum.ONLINE,
    label: 'Онлайн-запись',
  },
  {
    value: RecordTypeEnum.NONE,
    label: 'Отсутствует',
  },
];

// Блок «Тип записи» показывается только у записи с известным типом
// (issue/11350), поэтому «Отсутствует» в нём не выводится.
const knownRecordTypes = recordTypes.filter(
  ({ value }) => value !== RecordTypeEnum.NONE
);

export const recordTypesPart1 = knownRecordTypes.slice(0, 3);
export const recordTypesPart2 = knownRecordTypes.slice(3);
